import type { GameState, SelectRolesAction, ValidationResult } from "../types";
import {
  validateHostAction,
  validateRoleCopyLimits,
  validateRoleSelectionCount,
  validateSetupPhase,
} from "./common";

export function validateSelectRoles(
  state: GameState,
  action: SelectRolesAction,
): ValidationResult {
  const hostCheck = validateHostAction(
    state,
    action.actorPlayerId,
    "Only host can select roles",
  );
  if (!hostCheck.valid) return hostCheck;

  const phaseCheck = validateSetupPhase(state);
  if (!phaseCheck.valid) return phaseCheck;

  if (state.cards.length > 0) {
    return { valid: false, error: "Cards have already been dealt" };
  }

  const countCheck = validateRoleSelectionCount(state, action.roleIds);
  if (!countCheck.valid) return countCheck;

  const copyCheck = validateRoleCopyLimits(action.roleIds);
  if (!copyCheck.valid) return copyCheck;

  const masonCount = action.roleIds.filter(
    (roleId) => roleId === "mason",
  ).length;
  if (masonCount === 1) {
    return {
      valid: false,
      error: "Masons must be selected as a pair",
      details: { masonCount },
    };
  }

  return { valid: true };
}
